import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export function Mechanism() {
  return <SectionWrapper className="bg-white py-20" data-id="element-189">
      <h2 className="font-sans text-3xl md:text-4xl font-bold text-ink mb-12 text-center max-w-3xl mx-auto" data-id="element-190">
        Esto es lo que realmente ocurre cuando tu hijo entra en berrinche:
      </h2>

      <div className="space-y-6 font-sans text-lg text-ink-mid leading-relaxed mb-12 max-w-3xl mx-auto" data-id="element-191">
        <p data-id="element-192">
          Su cerebro racional, la parte que razona, escucha y coopera, se apaga
          temporalmente.
        </p>
        <p data-id="element-193">
          Lo que queda activo es el sistema de alarma. El modo supervivencia.
        </p>
        <p data-id="element-194">
          Está literalmente atrapado en una tormenta eléctrica emocional que su
          cuerpo todavía no sabe cómo manejar solo.
        </p>
      </div>

      {/* DIAGRAMA CEREBRO EN CRISIS (MEJORA 6) */}
      <div className="bg-midnight p-8 md:p-10 rounded-xl shadow-soft max-w-3xl mx-auto mb-8" data-id="element-195">
        <h3 className="font-sans text-2xl font-bold text-white mb-8 text-center" data-id="element-196">
          CEREBRO DEL NIÑO EN BERRINCHE
        </h3>

        <div className="space-y-4" data-id="element-197">
          {[{
          emoji: '🧠',
          text: 'Parte racional',
          state: '❌ APAGADA',
          color: 'text-red-400'
        }, {
          emoji: '🚨',
          text: 'Sistema de alarma',
          state: '🔴 AL MÁXIMO',
          color: 'text-red-400'
        }, {
          emoji: '👂',
          text: 'Capacidad de escuchar',
          state: '❌ BLOQUEADA',
          color: 'text-red-400'
        }, {
          emoji: '🤝',
          text: 'Capacidad de cooperar',
          state: '❌ INACCESIBLE',
          color: 'text-red-400'
        }].map((row, i) => <div key={i} className="flex items-center justify-between bg-white/10 p-4 rounded-lg" data-id="element-198">
              <div className="flex items-center gap-3" data-id="element-199">
                <span className="text-2xl" data-id="element-200">{row.emoji}</span>
                <span className="font-sans text-white font-medium" data-id="element-201">
                  {row.text}
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-202">
                <span className="text-white/50 hidden md:inline" data-id="element-203">→</span>
                <span className={`font-sans font-bold ${row.color}`} data-id="element-204">
                  {row.state}
                </span>
              </div>
            </div>)}
        </div>
      </div>

      <div className="bg-coral-light p-6 rounded-xl max-w-3xl mx-auto text-center mb-16" data-id="element-205">
        <p className="font-sans text-xl font-bold text-coral-dark" data-id="element-206">
          Los niños no aprenden a regularse solos. Aprenden tomando prestada la
          calma del adulto que tienen al frente.
        </p>
      </div>

      {/* DIAGRAMA EFECTO ESPEJO (MEJORA 7) */}
      <div className="max-w-4xl mx-auto" data-id="element-207">
        <h3 className="font-sans text-2xl font-bold text-ink mb-8 text-center" data-id="element-208">
          A esto lo llamamos el Método Espejo Rápido
        </h3>

        <div className="grid md:grid-cols-2 gap-0 rounded-xl overflow-hidden border border-hairline" data-id="element-209">
          <div className="bg-[#FFF0F0] p-8 text-center border-b md:border-b-0 md:border-r border-white/50" data-id="element-210">
            <h4 className="font-sans text-2xl font-bold text-red-600 mb-6" data-id="element-211">
              😤 TÚ SUBES
            </h4>
            <div className="space-y-3 font-sans text-lg font-medium text-red-900/80" data-id="element-212">
              <p data-id="element-213">Él sube MÁS 🔺</p>
              <p data-id="element-214">Crisis escala</p>
              <p data-id="element-215">Todos pierden</p>
            </div>
          </div>

          <div className="bg-[#F0FFF4] p-8 text-center" data-id="element-216">
            <h4 className="font-sans text-2xl font-bold text-green-700 mb-6" data-id="element-217">
              😌 TÚ BAJAS
            </h4>
            <div className="space-y-3 font-sans text-lg font-medium text-green-900/80" data-id="element-218">
              <p data-id="element-219">Él empieza a bajar 🔽</p>
              <p data-id="element-220">Crisis se corta</p>
              <p data-id="element-221">Tú ganas</p>
            </div>
          </div>
        </div>

        <p className="font-sans font-medium text-ink-mid text-center mt-10" data-id="element-222">
          No es magia. Es neurología básica aplicada al momento más caótico del
          día.
          <br data-id="element-223" />Y se puede aprender en una tarde.
        </p>
      </div>
    </SectionWrapper>;
}